/** Copy for how a fixed-amount Shopify discount is applied (once per order or
 *  to each eligible item). `amount` arrives already formatted in the store's currency. */
export const shopifyDiscountValueCopy = {
  oncePerOrderLabel: 'Only apply discount once per order',
  oncePerOrderHint: (amount: string) =>
    `${amount} comes off once per order, split across the eligible items.`,
  eachItemHint: (amount: string) => `${amount} comes off each eligible item in the order.`,
  eachItemSummary: (amount: string) => `${amount} off each item`,
  eachItemFreeWarning: (amount: string) =>
    `${amount} comes off each eligible item, so any eligible item priced at ${amount} or less becomes free. A minimum purchase doesn't prevent this.`,
} as const;
